export default () => {
  if (!window.app.sentry.enabled) {
    return;
  }

  import(/* webpackChunkName: "sentry" */ '@sentry/browser')
    .then((Sentry) => {
      Sentry.init({
        dsn: window.app.sentry.dsn,
        ignoreErrors: [
          'top.GLOBALS',
          'document.getElementsByClassName.ToString',
        ],
        ignoreUrls: [
          /graph\.facebook\.com/i,
          /connect\.facebook\.net\/en_US\/all\.js/i,
          /extensions\//i,
          /^chrome:\/\//i,
        ],
      });

      window.app.sentry.loaded = true;

      if (window.capturedErrors.length) {
        window.capturedErrors.forEach((capturedError) => {
          Sentry.captureException(new Error(capturedError[0]), {
            extra: {
              file: capturedError[1],
              lineno: capturedError[2],
              colno: capturedError[3],
            },
          });
        });
      }
    });
};
